import clarity from './clarity'

/** Creates Agentforce GTM payloads, sharing the common AMA event shape with Clarity. */
export default {
  onInitialize: (eventLabel: string, buttonLocation: string) => ({
    ...clarity.onInitialize(eventLabel, buttonLocation),
    customVariables: {
      buttonLocation,
      vendor: 'AgentForce',
    },
  }),
  onAction: clarity.onAction,
  onError: (errorMessage: string) => ({
    event: 'loadEventData',
    eventCategory: 'ERRORS',
    eventAction: 'Ask Me Anything',
    eventLabel: errorMessage,
    nonInteractive: true,
    customMetrics: {
      error: 1,
    },
    customVariables: {
      errorMessage,
      errorOrigin: 'Ask Me Anything',
      errorDetail: 'Response generation failed',
    },
    _clear: true,
  }),
}
